import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPersonDress } from '@fortawesome/free-solid-svg-icons';

const Comparison = () => {
    const [userName, setUserName] = useState('');
    const [userHeight, setUserHeight] = useState('');
    const [userGender, setUserGender] = useState('');
    const [showComparison, setShowComparison] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const handleCompare = () => {
        setShowComparison(true);

        if (userHeight < 170) {
            setErrorMessage("Mid tbh");
        }
        else if (userHeight > 195){
            setErrorMessage("Nahh, ur cap!");
        }
            else {
            setErrorMessage("HEIGHTMOGGED");
        }
    };

    const calculateHeightPixels = (height) => {
        const myHeightPx = 195; // your height in pixels
        const myHeightCm = 195; // your height in cm
        return (height / myHeightCm) * myHeightPx;
    };

    const userIcon = userGender === 'female' ? faPersonDress : faPerson;

    return (
        <ComparisonWrapper>
            <InputContainer>
                <h1>Enter your details to compare:</h1>
                <Input
                    type="text"
                    placeholder="Your name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                />
                <Input
                    type="number"
                    placeholder="Your height in cm"
                    value={userHeight}
                    onChange={(e) => setUserHeight(e.target.value)}
                />
                <Select
                    value={userGender}
                    onChange={(e) => setUserGender(e.target.value)}
                >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                </Select>
                <Button onClick={handleCompare}>Compare</Button>
                {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            </InputContainer>
            {errorMessage === "HEIGHTMOGGED" && (
                <MarqueeContainer>
                    <H1>HEIGHTMOGGED</H1>
                </MarqueeContainer>
            )}
            {showComparison && (
                <ComparisonContainer>
                    <h1>Comparison with {userName}:</h1>
                    <h2>Here is the actual size comparison...</h2>
                    <div className="comparison-figures">
                        <PersonContainer>
                            <FontAwesomeIcon icon={faPerson} style={{ height: '195px', color: '#03ff2c' }} />
                            <p>Me: 195 cm</p>
                        </PersonContainer>
                        <PersonContainer>
                            <FontAwesomeIcon icon={userIcon} style={{ height: `${calculateHeightPixels(userHeight)}px`, color: '#03ff2c' }} />
                            <p>{userName}: {userHeight} cm</p>
                        </PersonContainer>
                    </div>
                </ComparisonContainer>
            )}

        </ComparisonWrapper>
    );
};

const ComparisonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const InputContainer = styled.div`
  width: 90%;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #1e1e1e;
  padding: 20px;
  border-radius: 10px;

  h1 {
    margin-bottom: 20px;
    color: #03ff2c;
  }

  input, select, button {
    margin: 10px;
    padding: 10px;
    font-size: 16px;
    width: 100%;
    max-width: 300px;
  }
`;

const Input = styled.input`
  border: 2px solid #03ff2c;
  border-radius: 5px;
  background-color: #333;
  color: white;
`;

const Select = styled.select`
  border: 2px solid #03ff2c;
  border-radius: 5px;
  background-color: #333;
  color: white;
`;

const Button = styled.button`
  padding: 10px 20px;
  background-color: #03ff2c;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;

  &:hover {
    background-color: green;
  }
`;

const ComparisonContainer = styled.div`
  width: 90%;
  margin: 20px auto;
  text-align: center;
  background: #1e1e1e;
  padding: 20px;
  border-radius: 10px;
 

  h1, h2 {
    margin-bottom: 20px;
    color: #03ff2c;
  }

  .comparison-figures {
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    height: 300px;
    width: 35%;
    margin: auto;
  }
  @media (max-width: 1024px){
    .comparison-figures{
      width: 90%;
      margin: auto;
    }
  }
`;

const PersonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #03ff2c;

  svg {
    font-size: 10rem;
  }

  p {
    margin-top: 10px;
  }
`;

const ErrorMessage = styled.p`
  color: red;
`;

const MarqueeContainer = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 50px;
`;

const marqueeAnimation = keyframes`
  from {
    left: 100%;
  }
  to {
    left: -100%;
  }
`;

const H1 = styled.h1`
  font-size: 25px;
  position: absolute;
  top: 50%;
  white-space: nowrap;
  animation: ${marqueeAnimation} 15s linear infinite;
`;

export default Comparison;
